import { memo } from "react";
import classNames from "classnames";

import { TableCellProps } from "./types";
import TableCellContent from "./TableCellContent";

import styles from "./TableCell.module.css";



const TableCell = memo(function TableCell({ cellId, columnId, value, onOpenResponse }: TableCellProps) {
  const brandColumnMatch = columnId.match(/^brand_group_\d+$/);
  const shouldDrawDividerLeft = Boolean(brandColumnMatch);

  return (
    <td key={cellId} className={classNames(shouldDrawDividerLeft && styles["divider-left"])}>
      <TableCellContent columnId={columnId} value={value ?? null} onOpenResponse={onOpenResponse} />
    </td>
  );
});

export default TableCell;

